export default __webpack_public_path__ + "static/media/Purposeful Logo 2021 PINEAPPLE (2) Bailleur.30607385.png";